/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Invoice/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Invoice({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Invoice",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#6375EA"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Invoice.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-24S5YC': alignSelf,'--mt-2-24S5YC': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-24S5YC': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-24S5YC': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-24S5YC': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-24S5YC': opacity,'--w-10-24S5YC': typeof width === 'number' ? `${width}px` : width,'--h-11-24S5YC': typeof height === 'number' ? `${height}px` : height,'--f-12-24S5YC': fill,'--a-7-24S5YC': isAnimated ? animation : "none",'--sd-8-24S5YC': isAnimated ? strokeDashoffset : 0,'--sd-9-24S5YC': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Invoice.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M0 1.45C0 .625.696 0 1.5 0h11c.804 0 1.5.625 1.5 1.45v5.6c0 .176-.032.343-.09.497a4.498 4.498 0 00-7.059.953H1.501C.696 8.5 0 7.875 0 7.05v-5.6zm9 2.8a2 2 0 11-4 0 2 2 0 014 0zm-6.975.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm9.2-.75a.75.75 0 100 1.5.75.75 0 000-1.5zm2.775 7a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0zm-1.808-1.442a.625.625 0 010 .884l-1 1a.625.625 0 11-.884-.884l1-1a.625.625 0 01.884 0z"
 style={{'--f-12-24S5YC': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}